import { render } from "./notifications-add.vue?vue&type=template&id=92f00512"
import script from "./notifications-add.vue?vue&type=script&lang=js"
export * from "./notifications-add.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__